/* eslint-disable linebreak-style */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */

import React, { Component } from 'react';

import Button from 'elements/Button';

import NotFound from 'assets/images/NotFound.png';

// eslint-disable-next-line react/prefer-stateless-function
export default class NotFoundPage extends Component {
  render() {
    return (
      <main id="main" className="flex flex-col w-full h-screen justify-center bg-theme-blue">
        <div className="flex w-full justify-center">
          <img src={NotFound} alt="Not Found" className="sm:w-3/4 xl:w-5/12" />
        </div>
        <h1 className="text-white text-2xl text-center mt-5 font-serif px-4">
          This page wandered off — let&apos;s get you home.
        </h1>
        <div className="flex flex-wrap gap-3 justify-center mt-5 px-4">
          <Button href="/" type="link" className="px-6 py-3 bg-theme-gold text-theme-blue font-medium rounded-xl hover:bg-theme-gold-dark transition duration-200">
            Back to home
          </Button>
          <Button href="/programs" type="link" className="px-6 py-3 bg-transparent text-white font-medium border-2 border-white/40 rounded-xl hover:bg-white/10 transition duration-200">
            View programs
          </Button>
        </div>
      </main>
    );
  }
}
